const paths = {
  home: '/',
  paymentReceipt: '/payment-receipt',
  tipResult: '/tip-result',
  proInRide: '/pro-in-ride',
} as const;

export default paths;
